module.exports = __webpack_public_path__ + "static/media/charcoal-gery-95.24af7ec9.jpg";